import { View3dConfigurationDto } from '@canvas-logic/clp-viewer3d';
import { IConfiguratorUIDto } from '@canvas-logic/clp-api-types';

// TODO: type is incompatible
export const uiFallBack: Partial<IConfiguratorUIDto> = {
  localization: 'en',
  layout: {
    controlsHidden: false,
  },
} as any;
export const view3dFallBack: View3dConfigurationDto = {
  views: [],
  hierarchy: {
    root: {
      partId: 'empty',
      children: [],
    },
  },
  camera: {},
  parts: [
    {
      id: 'empty',
      view: {
        selector: 'view',
        match: {
          '*': '*',
        },
      },
      materials: [],
    },
  ],
  materials: [],
} as any;

export const ConfiguratorParams = {
  link: 'link',
  draft: 'draft',
  catalogId: 'catalogId',
  configurationId: 'configurationId',
  hideConfigurationControls: 'hideConfigurationControls',
  background: 'background',
  mode: 'mode',
};
